<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col>
        <!-- main text -->
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('common.about') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('tempering.about.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('tempering.about.text.01')}}<br>
            {{ $t('tempering.about.text.02')}}
          </v-col>
        </v-row>
        <!-- pros checked -->
        <v-row class="py-8 max-width-1000 mx-auto">
          <v-col
            v-for="(item,index) in pros"
            :key="index"
            cols="12" sm="6"
            class="px-12">
            <v-row align="center">
              <v-col cols="2"
                style="min-width: 66px;">
                <v-icon
                  size="42"
                  color="success">
                  mdi-checkbox-marked-outline
                </v-icon>
              </v-col>
              <v-col>
                {{ $t(item.text)}}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'TemperingAbout',
    extends: DataComponentBase,

    data: () => ({
      pros: [
        { text: "tempering.about.pros.01" },
        { text: "tempering.about.pros.02" },
        { text: "tempering.about.pros.03" },
        { text: "tempering.about.pros.04" },
        { text: "tempering.about.pros.05" },
        { text: "tempering.about.pros.06" },
      ],
    }),

    methods: {

    },
  }
</script>
